import React from 'react';
import { Button, palette } from '@m12s/component-library';
import styled from 'styled-components';

const StyledButton = styled(Button)`
  background-color: ${palette.Indigo600};
  color: ${palette.White};
  font-size: 0.875rem;
  line-height: 1.25rem;
  &:hover {
    background-color: ${palette.Indigo700};
  }
`;

const PrimaryButton = ({ style, className, children, ...props }) => {
  return (
    <StyledButton
      variant="primary"
      style={style}
      className={className}
      {...props}
    >
      {children}
    </StyledButton>
  );
};

export default PrimaryButton;
